<template>
  <div>
    <p class="mt-5">Options:</p>
    <div class="flex flex-col">
<!--      <div class="flex">-->

<!--        <a-form-item v-if="change_tax">-->
<!--          <a-input-number v-decorator="['tax',{ initialValue: null }]" placeholder="Tax" :min="1" :max="100" suffix="%" style="border-radius: 3px"/>-->
<!--        </a-form-item>-->
<!--      </div>-->
<!--      <div class="flex">-->
<!--        <a-form-item>-->
<!--          <a-checkbox v-decorator="['is_apply_second_tax',{ initialValue: false, valuePropName: 'checked' }]" @change="handleChangeSecondTax">-->
<!--            Apply secondary tax-->
<!--          </a-checkbox>-->
<!--        </a-form-item>-->
<!--        <a-form-item v-if="change_second_tax">-->
<!--          <a-input-number v-decorator="['second_tax',{ initialValue: null }]" placeholder="Second tax" :min="1" :max="100" suffix="%" style="border-radius: 3px" />-->
<!--        </a-form-item>-->
<!--      </div>-->
<!--      @change="handleChangeTax"-->
<!--      fgfgffgfg-->
      <a-form-item>
        <a-checkbox v-decorator="['is_apply_tax',{ initialValue: false, valuePropName: 'checked' }]" :disabled="is_disabled && form.getFieldValue('is_apply_tax')">
          Apply tax
        </a-checkbox>
      </a-form-item>
      <a-form-item>
        <a-checkbox v-decorator="['is_skip_approval_process',{ initialValue: false, valuePropName: 'checked' }]">
          Skip the bill approval process
        </a-checkbox>
      </a-form-item>
    </div>
  </div>
</template>

<script>
export default {
  name: "BillFaxComponent",
  props:{
    form:{
      type: Object,
    },
    is_disabled:{
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      change_tax      : false,
      change_second_tax: false,
    }
  },
  methods: {
    handleChangeTax(e){
      this.change_tax = e.target.checked
    },
    handleChangeSecondTax(e){
      this.change_second_tax = e.target.checked
    }
  },
}
</script>

<style scoped>

</style>
